import Axios from '../services/Axios'

export function getProviders() {
  return Axios.getInstance().get('/api/v1/providers')
}
